import React, { useRef, useState } from 'react'
import { Form } from './Form'
import { Table } from './Table'
import { Toast } from "primereact/toast";

const BranchAllocationSetting = () => {
    const [reload, setReload] = useState(false);
    const [modal, setModal] = useState({ singleData: {}, open: false });
    const toast = useRef<any>(null);

    const onHideDialog = () => {
        setModal({ singleData: {}, open: false });
    };

    return (
        <>
            <Form open={modal.open} singleData={modal.singleData} reload={reload} setReload={setReload} hideDialog={onHideDialog} toast={toast} />
            <Table reload={reload} setModal={setModal} toast={toast} />
            <Toast ref={toast} />
        </>
    )
}

export default BranchAllocationSetting;